import React, { useState } from "react";
import { Col, Container, Form, InputGroup, Button } from "react-bootstrap";
import { labelToKey, reverseDateString } from "../../utils/utilities";
import { RenderInputErrorOther } from "../RenderInputError";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.scss";

class InputModel {
  constructor({
    label = "Input Field",
    value = "",
    mandatory = true,
    read_only = false,
    im_type = "text", //{text, password, number}
    placeholder = "please fill in the form input",
    err_message = [],
    is_divider = false,
    is_hidden = false,
    is_edited = false,
    key = "",
    form_tipe = "text", // {text, select, radio, datepicker },
    select_options = [], // {special case for all form_tipe except TEXT }
  }) {
    this.label = label;
    this.value = value;
    this.mandatory = mandatory;
    this.im_type = im_type;
    this.placeholder = placeholder;
    this.err_message = err_message;
    this.is_divider = is_divider;
    this.is_hidden = is_hidden;
    this.is_edited = is_edited;
    this.key = key;
    this.read_only = read_only;
    this.form_tipe = form_tipe;
    this.select_options = select_options;
  }

  toMap() {
    let fkey = this.key ? this.key : labelToKey({ label: this.label });
    return {
      [fkey]:
        this.form_tipe === "datepicker"
          ? reverseDateString(this.value)
          : this.value,
    };
  }

  static modelToMaps = ({ models = [] }) => {
    let maps = {};
    models.forEach(function (model) {
      if (model.is_divider || !model.is_edited) return;
      maps = { ...maps, ...model.toMap() };
    });
    return maps;
  };
}

const FormGenerator = ({
  inputs = [],
  onSubmit = (values) => {},
  loginType,
}) => {
  const [inputList, setInputList] = useState([...inputs]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const list = [...inputList];
    list[index].value = value;
    list[index].is_edited = true;

    if (!value && list[index].mandatory) {
      list[index].err_message = ["this field are mandatory"];
    } else {
      list[index].err_message = [];
    }

    setInputList(list);
  };

  const handleInputDateChange = (date, index) => {
    const list = [...inputList];
    list[index].value = date;
    setInputList(list);
  };

  const renderInput = (data, dindex) => {
    let component;
    switch (data.form_tipe) {
      case "select":
        component = (
          <Form.Select
            readOnly={data.read_only}
            type={data.im_type}
            placeholder={data.placeholder}
            value={data.value}
            onChange={(e) => handleInputChange(e, dindex)}
          >
            {data.select_options.map((item, index) => (
              <option key={`option-${index}`} value={item.value}>
                {item.name}
              </option>
            ))}
          </Form.Select>
        );
        break;

      default:
        component = (
          <Form.Control
            type={data.im_type}
            placeholder={data.placeholder}
            value={data.value}
            disabled={
              loginType == 1
                ? data?.label == "Email"
                  ? true
                  : false
                : loginType == 2
                ? data?.label == "Phone Number"
                  ? true
                  : false
                : false
            }
            onChange={(e) => handleInputChange(e, dindex)}
          />
        );
        break;
    }

    return component;
  };

  return (
    <Container className="form-generator-container">
      <Form>
        {inputs.map((data, index) => {
          if (data.is_hidden) return <div key={`form-group-${index}`} />;
          return !data.is_divider ? (
            data.form_tipe === "datepicker" ? (
              <Form.Group
                as={Col}
                key={`form-group-${index}`}
                className="group"
              >
                <Form.Label>{data.label}</Form.Label>
                <DatePicker
                  onChange={(e) => handleInputDateChange(e, index)}
                  selected={data.value}
                />
                <RenderInputErrorOther messages={data.err_message} />
              </Form.Group>
            ) : (
              <Form.Group
                as={Col}
                key={`form-group-${index}`}
                className="group"
              >
                <Form.Label>{data.label}</Form.Label>
                <InputGroup className="mb-3">
                  {renderInput(data, index)}
                </InputGroup>
                <RenderInputErrorOther messages={data.err_message} />
              </Form.Group>
            )
          ) : (
            <Container key={`form-group-${index}`} className="divider">
              {data.label}
            </Container>
          );
        })}
        <div style={{ padding: "10px" }}>
          <Button
            variant="danger"
            className="btn-change border-0"
            onClick={() => onSubmit(inputList)}
          >
            Save
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export { FormGenerator, InputModel };
